import { EventListItem, ResourceSectionCard, Stack } from '@all-manager/design-system-v2';
import { useMemo } from 'react';
import type { EventDatabse } from "../../../../types";
import EventMenuActions from "./EventMenuActions/EventMenuActions";
import { isEventTodayOrUpcoming } from "./useActivitiesTab";

type Props = {
  events: EventDatabse[];
  isLoading: boolean;
};

function getEventSubtitle(event: EventDatabse) {
  const subtitle = [event.provider_name, event.contact_name].filter(Boolean).join(' · ');

  return subtitle || undefined;
}

export default function UpcomingEventsSection(props: Props) {
  const eventsToDisplay = useMemo(() => {
    return props.events.filter(isEventTodayOrUpcoming);
  }, [props.events]);

  return (
    <ResourceSectionCard
      variant="rendezVous"
      title="Prochains rendez-vous"
      count={eventsToDisplay.length}
      isLoading={props.isLoading}
      isEmpty={eventsToDisplay.length === 0}
      emptyLabel="Aucun rendez-vous planifié. Planifiez-en un avec « Nouvelle action »."
    >
      <Stack spacing={0.5}>
        {eventsToDisplay.map((event) => (
          <EventListItem
            key={event.id}
            title={event.title || 'Rendez-vous'}
            date={event.date}
            end_date={event.end_date}
            all_day={event.all_day}
            subtitle={getEventSubtitle(event)}
            action={<EventMenuActions event={event} />}
          />
        ))}
      </Stack>
    </ResourceSectionCard>
  );
}
